export default __webpack_public_path__ + "static/media/illustration-algostudy-n-m.0795e37a.png";